import ActionButton from 'lib/src/components/button/ActionButton';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Title from 'lib/src/components/typography/Title';
import { CustomValidateFunction } from 'lib/src/types/shared/formValidation';
import { isGA } from 'lib/src/constants/environment';
import { Link } from 'react-router-dom';

const LoginForm: React.FC<LoginFormProps> = ({
    formState: { email, password },
    handleChange,
    handleSubmit,
    isPosting,
    customValidate,
    error,
}) => (
    <>
        <Title>Login</Title>
        <Form onSubmit={handleSubmit} isPosting={isPosting} omitButtons error={error}>
            <FormRow>
                <TextInput
                    name="email"
                    type="email"
                    value={email}
                    label="Email address"
                    onChange={handleChange}
                    required
                />
            </FormRow>
            <FormRow>
                <TextInput
                    name="password"
                    value={password}
                    label="Password"
                    onChange={handleChange}
                    type="password"
                    required
                    customValidate={customValidate}
                />
            </FormRow>
            <p>
                <Link to="/auth/forgot-password">Forgot password?</Link>
            </p>
            <ButtonRow alignment="right">
                <ActionButton
                    icon="sign-in"
                    isPosting={isPosting}
                    extraClasses={`${isGA ? 'ga' : 'ix'}`}
                >
                    Login
                </ActionButton>
            </ButtonRow>
        </Form>
    </>
);

interface LoginFormProps {
    handleChange: <T>(name: 'email' | 'password', value: T) => void;
    handleSubmit: () => void;
    isPosting: boolean;
    customValidate: CustomValidateFunction<string>;
    formState: {
        email: string;
        password: string;
    };
    error: string | null;
}

export default LoginForm;
